import BestWorstSegment from './BestWorstSegment';

export default BestWorstSegment;